import { useState } from 'react'
import BaseDialog from '@common/components/BaseDialog'
import { TextField } from '@mui/material'

export interface ReasonDialogProps {
  onConfirm: (reason: string) => void
  onCancel: () => void
  open: boolean
  title: string
  description: string
  confirmLabel: string
  cancelLabel?: string
  maxLength?: number
  placeholder?: string
}

const ReasonDialog = ({
  onConfirm,
  onCancel,
  open,
  title,
  description,
  confirmLabel,
  cancelLabel = 'Cancel',
  maxLength = 300,
  placeholder = 'Provide a reason',
}: ReasonDialogProps) => {
  const [reason, setReason] = useState('')
  const [charCount, setCharCount] = useState(0)

  const handleReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    if (value.length <= maxLength) {
      setReason(value)
      setCharCount(value.length)
    }
  }

  const handleSubmit = () => {
    onConfirm(reason)
    setReason('')
    setCharCount(0)
  }

  const handleCancel = () => {
    onCancel()
    setReason('')
    setCharCount(0)
  }

  return (
    <BaseDialog
      title={title}
      description={description}
      open={open}
      onClose={handleCancel}
      onSubmit={handleSubmit}
      width={600}
      submitLabel={confirmLabel}
      cancelLabel={cancelLabel}
    >
      <TextField
        fullWidth
        multiline
        rows={4}
        label="Reason"
        placeholder={placeholder}
        value={reason}
        onChange={handleReasonChange}
        variant="outlined"
        helperText={`Optional. ${charCount} of ${maxLength} symbols`}
      />
    </BaseDialog>
  )
}

export default ReasonDialog
